export default __webpack_public_path__ + "static/media/notification-bell-icon-gray.7446cb0c.svg";